import { formatInTimeZone } from 'date-fns-tz';
import { oneDay } from 'utils/time';

export const getDayString = (day: string, abbrTimezone: string, format: string) => {
  const now = Date.now();

  const today = formatInTimeZone(now, abbrTimezone, format);

  if (day === today) return `Today`;

  let tomorrow = formatInTimeZone(now + oneDay, abbrTimezone, format);

  // DST could mean that 24 hours ahead is the same day
  if (tomorrow === today) tomorrow = formatInTimeZone(now + oneDay * 1.5, abbrTimezone, format);
  if (day === tomorrow) return `Tomorrow`;

  let yesterday = formatInTimeZone(now - oneDay, abbrTimezone, format);

  // DST could mean that 24 hours ago is the same day
  if (yesterday === today) yesterday = formatInTimeZone(now - oneDay * 1.5, abbrTimezone, format);
  if (day === yesterday) return `Yesterday`;
  return day;
};
